// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"7":"a1b843a798e447f93f4f","527":"6c23168d96cf17e5202f","640":"2de4d02a466c7e2f3b22"}[chunkId] + ".js";
};